// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","setupPageLayout":"HsZ78V","setupPageBanner":"tofs4O","textStrikethrough":"phYtVM"};